import type { FC } from "react";
import { Fragment, useMemo } from "react";
import { ExtraStateContext } from "../..";
import { UserSelect } from "../../../../../../../components/input/select/UserSelect";
import { approverType } from "../../../../../../../constants/itCodeRequestConstants";
import { useSelector } from "../../../../../../../store/store";
import InformationList from "../../../../../components/InformationList";
import { ApprovalHistory } from "../../../../../components/Progress/molecule/ApprovalHistory";
import TableModal from "../../../../../components/detail";
import CommentSection from "../../../../../info-technology-process/commentsection/comment-sections";
import { useProcess } from "../../../../../process-context";
import { FileAttachmentCard } from "../../../../../upload";
import { eApprovedESCCOptions } from "../../../../companyRequestContants/companyRequestContants";
import useApprovalProcess from "../../../../securityCardUnits/hooks/use-approval-prcoess";
import { useLongTermTableColumns } from "../table-column";

const LongTermContent: FC = () => {
  const { Request, approvalStep, approvalType, comment, setComment, pickedItHead, onApproverChange } =
    useProcess<ExtraStateContext>();

  const tableColumns = useLongTermTableColumns();

  const { fields } = Request;

  const { canApproval } = useApprovalProcess({
    data: Request as any,
    steps: [
      {
        approver: 'eApprovedBy',
        status: 'eApprovedStatus'
      },
      {
        approver: 'eApprovedByITLead',
        status: 'eApprovedByITLeadStatus'
      },
      {
        approver: 'eApprovedByITHead',
        status: 'eApprovedByITHeadStatus'
      },
      {
        approver: 'eAssignee',
        status: 'eAssigneeStatus'
      },
    ]
  })

  /**
   * Selector
   */
  const user = useSelector((state) => state.user);

  const {
    eDeptHeadComment,
    eITLeadComment,
    eITHeadComment,
    eAssigneeComment,
    eApprovedBy,
    eApprovedByITLead,
    eAssignee,
  } = fields;

  const fullColData = useMemo(() => {
    const eDeptHeadCommentData = eDeptHeadComment ? JSON.parse(eDeptHeadComment) : [];
    const eITLeadCommentData = eITLeadComment ? JSON.parse(eITLeadComment) : [];
    const eITHeadCommentData = eITHeadComment ? JSON.parse(eITHeadComment) : [];
    const eAssigneeCommentData = eAssigneeComment ? JSON.parse(eAssigneeComment) : [];

    return [
      {
        content: <TableModal data={JSON.parse(Request.fields.eContent)} columns={tableColumns} />,
      },
      {
        content: (
          <Fragment>
            Tệp đính kèm
            <div className="mt-2 d-flex flex-column">
              <FileAttachmentCard
                listFile={Request.fields.eFileContent ? JSON.parse(Request.fields.eFileContent) : []}
              />
            </div>
          </Fragment>
        ),
      },
      {
        content: (
          <Fragment>
            Lịch sử phê duyệt
            <ApprovalHistory>
              <ApprovalHistory.Content
                hidden={!eDeptHeadComment}
                data={eDeptHeadCommentData}
                highlight={`Thủ trưởng CQ/ĐV, ${eApprovedBy.split("|")[1]}`}
              />

              <ApprovalHistory.Content
                hidden={!eITLeadComment}
                data={eITLeadCommentData}
                highlight={`Bộ phận cấp giấy phép VPCT, ${eApprovedByITLead.split("|")[1]}`}
              />

              <ApprovalHistory.Content
                hidden={!eITHeadComment}
                data={eITHeadCommentData}
                highlight={`Đã gửi công văn sang bộ công an, ${eApprovedByITLead.split("|")[1]}`}
              />

              <ApprovalHistory.Content
                hidden={!eAssigneeComment}
                data={eAssigneeCommentData}
                highlight={`Bộ phận thực hiện cấp giấy phép VPCT, ${eAssignee.split("|")[1]}`}
              />

              <ApprovalHistory.Input
                hidden={!canApproval}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </ApprovalHistory>
          </Fragment>
        ),
      },
      {
        content: (
          <Fragment>
            Thông tin trao đổi
            <div className="mt-2">
              <CommentSection comments={[]} data={Request} user={user} id={10} className="mb-4" />
            </div>
          </Fragment>
        ),
      },
      {
        hidden: approvalType !== approverType.itlead || approvalStep !== approvalType,
        content: (
          <Fragment>
            Thực hiện cấp thẻ
            <div className="people_picker-custom-detail">
              <UserSelect
                name="Vui lòng chọn bộ phận hành chính VPCT"
                onTouched={() => 1}
                placeholder="Vui lòng chọn bộ phận Thực hiện cấp thẻ"
                options={eApprovedESCCOptions}
                value={pickedItHead}
                onChange={onApproverChange}
              />
            </div>
          </Fragment>
        ),
      },
    ];
  }, [eDeptHeadComment, eITLeadComment, eITHeadComment, eAssigneeComment, Request, tableColumns, eApprovedBy, eApprovedByITLead, eAssignee, canApproval, comment, user, approvalType, approvalStep, pickedItHead, onApproverChange, setComment]);

  return (
    <InformationList
      size="full-col"
      data={fullColData}
      renderContent={(item) => item.content}
      getItemHidden={(item) => item.hidden}
    />
  );
};

export default LongTermContent;
